import { styled } from '@mui/material';

const Error = styled('p')({
  color: 'red',
  fontSize: 12,
});

export default Error;
